import { meanBy, sumBy } from 'es-toolkit';
import paper from 'paper';

import { updateModifiedPaperItems } from '../../actions/annotations';
import { ReduxDispatch } from '../../actions/thunkActions';
import { RenderedItem } from './paperItemTranslator';

export function alignSelectedItems(direction: 'vertical' | 'horizontal', dispatch: ReduxDispatch) {
  const alignmentProperty = direction === 'vertical' ? 'x' : 'y';

  const selectedItems = (paper.project.activeLayer.children as unknown as readonly RenderedItem[]).filter(
    (paperItem) => paperItem.reduxSelected,
  );
  if (selectedItems.length < 2) {
    return;
  }

  const averageLeftPosition = meanBy(selectedItems, (item) => item.bounds[alignmentProperty]);
  for (let i = 0; i < selectedItems.length; i++) {
    selectedItems[i].bounds[alignmentProperty] = averageLeftPosition;
  }

  paper.project.view.update();

  dispatch(updateModifiedPaperItems(selectedItems));
}

export function horizontallyDistributeSelectedItems(dispatch: ReduxDispatch) {
  const selectedItems = (paper.project.activeLayer.children as unknown as readonly RenderedItem[]).filter(
    (paperItem) => paperItem.reduxSelected,
  );

  if (selectedItems.length < 2) {
    return;
  }

  const annotationsWidth = sumBy(selectedItems, (item) => item.bounds.width);
  const leftOfLeftItem = Math.min(...selectedItems.map((item) => item.bounds.left));
  const rightOfRightItem = Math.max(...selectedItems.map((item) => item.bounds.right));

  const columnWidth = rightOfRightItem - leftOfLeftItem;
  const emptyWidth = columnWidth - annotationsWidth;
  const averageGap = emptyWidth / (selectedItems.length - 1);

  const sortedItems = selectedItems.toSorted((a, b) => a.bounds.left - b.bounds.left);

  let currentX = leftOfLeftItem;
  for (let i = 0; i < sortedItems.length; i++) {
    sortedItems[i].bounds.point.x = currentX;

    currentX += sortedItems[i].bounds.width + averageGap;
  }

  paper.project.view.update();

  dispatch(updateModifiedPaperItems(selectedItems));
}

export function verticallyDistributeSelectedItems(dispatch: ReduxDispatch) {
  const selectedItems = (paper.project.activeLayer.children as unknown as readonly RenderedItem[]).filter(
    (paperItem) => paperItem.reduxSelected,
  );

  if (selectedItems.length < 2) {
    return;
  }

  const annotationsHeight = sumBy(selectedItems, (item) => item.bounds.height);
  const topOfTopItem = Math.min(...selectedItems.map((item) => item.bounds.top));
  const bottomOfBottomItem = Math.max(...selectedItems.map((item) => item.bounds.bottom));

  const columnHeight = bottomOfBottomItem - topOfTopItem;
  const emptyHeight = columnHeight - annotationsHeight;
  const averageGap = emptyHeight / (selectedItems.length - 1);

  const sortedItems = selectedItems.toSorted((a, b) => a.bounds.top - b.bounds.top);

  let currentY = topOfTopItem;
  for (let i = 0; i < sortedItems.length; i++) {
    sortedItems[i].bounds.point.y = currentY;

    currentY += sortedItems[i].bounds.height + averageGap;
  }

  paper.project.view.update(true);

  dispatch(updateModifiedPaperItems(selectedItems));
}
